export default "__VITE_ASSET__C$V0CWON__"